<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">
              {{cvCardTitle}}
            </h4>
          </template>

          <template v-slot:body>
            <form action="#" v-if="vmUserFormData && Object.keys(vmUserFormData).length > 0">
              <div class="form-row">
                <div class="row iq-card w-100 p-2">
                  <h4>Update User Details</h4>
                  <div class="col-md-12 mt-4">
                    <label for="validationuser_name">{{cvUserNameLabel}}</label>
                    <input
                      disabled
                      v-model="vmUserFormData.user_name"
                      type="text"
                      class="form-control"
                      required
                    />
                  </div>
                  <div class="col-4 mt-4">
                    <label for="validationuser_role">{{cvUserRoleLabel}}</label>
                    <select
                      v-model="vmUserFormData.user_role"
                      track-by="user_role_name"
                      label="user_role_name"
                      class="form-control">
                      <option v-for="item of cvUserRoleOptions" :key="item.id.user_role_id" :value="item.user_role_id">
                        {{item.user_role_name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-12 mt-4">
                    <label for="validationuser_name">{{cvRefCodeLabel}}</label>
                    <ValidationProvider name="Reference Code"  v-slot="{ errors }" rules="required|min:6|max:6|regex:^[a-zA-Z0-9 '.-]*$">
                      <input
                        v-model="vmUserFormData.ref_code"
                        type="text"
                        class="form-control"
                        />
                      <span><small>Employee Reference code (6-char code (A–Z, 0–9))</small></span><br>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-12 mt-4">
                    <label for="validationuser_name">{{cvMeetingLinkLabel}}</label>
                    <input
                      v-model="vmUserFormData.meeting_link"
                      type="text"
                      class="form-control"
                      required
                    />
                    <span><small>Calendly for google meeting scheduler link </small></span>
                  </div>
                  <div class="col-12 mt-2">
                    <button type="button" class="mt-3 btn btn-primary mr-1" @click="userEdit">Save</button>
                  </div>
                </div>

                <div class="row iq-card w-100 p-2">
                  <div v-if="vmUserFormData.org_id == 'GIDE_ORG_1'">
                    <h4>GIDEPreneur Settings</h4>
                    <div>
                      Associate User with GIDEPreneur's Organisation
                      <span class="primary-color pointer" @click="gotoOrgaAdd">Click to Add Organisation</span>
                    </div>
                    <multiselect
                      v-model="selectedUniversity"
                      :options="cvUnivOptions"
                      placeholder="Select Organisation"
                      label="org_name"
                      @search-change="organisationList($event)"
                      track-by="org_id"
                    />
                    <div class="col-md-12 mt-2">
                      <button type="button" class="btn btn-primary" @click="userOrgEdit">Update</button>
                    </div>
                  </div>
                  <div v-else>
                    <h2 :v-html="vmUserFormData"></h2>
                  </div>
                </div>

                <div class="row iq-card w-100 p-2" v-if="vmUserFormData.user_role">
                  <div>
                    <h4>GIDE User Organisation Setting</h4>
                    <label>Associate Organisation with GIDE User</label>
                    <multiselect
                      v-model="selectedUniversity"
                      :options="cvUnivOptions"
                      placeholder="Select Organisation"
                      label="org_name"
                      @search-change="organisationList($event)"
                      track-by="org_id"
                    />
                    <div class="col-md-12 mt-2">
                      <button type="button" class="btn btn-primary" @click="userEdit">Add</button>
                    </div>
                  </div>
                </div>

                <div class="row iq-card w-100 p-2">
                  <div>
                  <h4>GIDE User Organisation List</h4>
                    <label>
                      <span>Organisations Associated with</span>&nbsp;
                      <span class="primary-color">{{ vmUserFormData.user_name }}</span>
                    </label>
                    <template v-for="(org, index) of vmUserFormData.roles">
                      <h5 class="mt-3" :key="index+'org'">
                        {{ index }}. {{ org.module_type == "SCH" ? "School" : org.module_type == "UNIV" ? "University" : "Organisation" }} - {{org.org_name}} <small>({{ org.status }})</small><br><br>
                        <button type="button" class="btn btn-sm btn-primary pointer mr-2" @click="gotoManageOrganisation('organisations', org.module_type, org.module_obj_id)">View</button>
                        <button type="button" class="btn btn-sm btn-primary pointer mr-2" @click="gotoManageOrganisation('organisation_edit', org.module_type, org.module_obj_id, 'manage-users')">Manage Users</button>
                        <button type="button" class="btn btn-sm btn-primary pointer mr-2" @click="gotoManageOrganisation('organisation_edit', org.module_type, org.module_obj_id, 'edit-roles')">Manage Roles</button>
                        <button type="button" class="btn btn-sm btn-primary pointer mr-2" @click="deleteRole(org.module_obj_id, index)">Remove</button>
                      </h5>
                    </template>
                  </div>
                </div>

              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Multiselect from "vue-multiselect"
import { User } from "../../../FackApi/api/user.js"
import { UserRole } from "../../../FackApi/api/userRole.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { Organisations } from "../../../FackApi/api/organisation.js"

export default {
  name: "UserRoleEdit",
  components: {
    Multiselect
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propUserObj: {
      type: Object,
      default: function () {
        return {
          "user_name": "",
          "user_role": "",
          "org_name": ""
        }
      }
    }
  },
  data () {
    return {
      apiName: "user_edit_console",
      cvSelectBoxText: "Select ",
      cvCardTitle: "Manager User Role & Organisation",
      cvSubmitBtn: "Edit",
      cvUserNameLabel: "User Name",
      cvUserRoleLabel: "Change User Role",
      cvRefCodeLabel: "User Reference code",
      cvMeetingLinkLabel: "Meeting Link",
      showToast: false,
      cvLoadingStatus: false,
      cvUserRoleOptions: [],
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "User",
      cvUnivOptions: [],
      vmUserFormData: {},
      indd: 0,
      currUserId: null,
      selectedUniversity: null,
      cvModuleTypeLabel: "Organisation Type",
      univFiltersList: { "org_name , org_id , org_uid": [] },
      module_data: {},
      ModuleType: "",
      cvUserTypesOptions: [
        { key: "UNIV", value: "University" },
        { key: "ORG", value: "Organization" },
        { key: "SCH", value: "School" }
      ],
      cvModuleNameLabel: "Select Your"
    }
  },
  async mounted () {
    await this.userRoleList()
    await this.userView()
    await this.organisationList()
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  methods: {
    change () {
      this.indd += 1
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmUserFormData) {
          if (!this.vmUserFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * userView
     */
    async userView () {
      try {
        if (this.propOpenedInModal) {
          this.currUserId = this.propUserObj.user_id
        }
        else {
          this.currUserId = this.$route.params.user_id
        }

        let userViewResp = await User.userViewWithRoles(this, { curr_user_id: this.currUserId })
        if (userViewResp && userViewResp.resp_status) {
          this.vmUserFormData = userViewResp.resp_data.data
        }

        if (this.vmUserFormData.user_role_name && this.cvUserRoleOptions.length) {
          let userIndex = this.cvUserRoleOptions.findIndex(user => user.user_role_name === this.vmUserFormData.user_role_name)
          if (userIndex >= 0) {
            this.vmUserFormData.user_role = this.cvUserRoleOptions[userIndex]
            this.vmUserFormData.user_role_name = this.vmUserFormData.user_role
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at userView() and Exception:", err.message)
      }
    },
    /**
     * deleteRole
     */
    async deleteRole (moduleObjId, index) {
      try {
        const userModuleDelete = await UserRole.udfInviteDelete(this, this.currUserId, moduleObjId)
        if (userModuleDelete.resp_status) {
          this.vmUserFormData.roles.splice(index, 1)
        }
      }
      catch (error) {
        console.log("Exception IN deleteRole", error)
      }
    },
    /**
     * goto Manage Organisation Actions
     * Ex: this.$router.push("/organisation_edit/UNIV/GIDE_ORG_1#manage-users")
     *
     * #manage-users
     * #edit-roles
     */
    async gotoManageOrganisation (pageName = "organisations", orgType = "ORG", orgId = "GIDE_ORG_1", action = null) {
      let url = `/${pageName}/${orgType}/${orgId}`
      url = action ? `${url}#${action}` : url

      window.open(url, "_blank")
    },
    /**
     * userEdit
     */
    async userEdit () {
      try {
        this.cvLoadingStatus = true

        let payload = {
          curr_user_id: this.vmUserFormData.user_id,
          user_role: this.vmUserFormData.user_role,
          ref_code: this.vmUserFormData.ref_code,
          meeting_link: this.vmUserFormData.meeting_link
        }

        if (this.selectedUniversity && this.selectedUniversity.org_id) {
          payload.org_id = this.selectedUniversity.org_id
          payload.org_type = this.selectedUniversity.type
        }

        let userEditResp = await User.userEditConsole(this, payload)
        ApiResponse.responseMessageDisplay(this, userEditResp)

        if (userEditResp && !userEditResp.resp_status) {
          return false
        }
      }
      catch (err) {
        console.error("Exception occurred at userEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * userRoleList
     */
    async userRoleList () {
      try {
        let userRoleListResp = await UserRole.userRoleListConsole(this)
        if (userRoleListResp && !userRoleListResp.resp_status) {
          return false
        }
        this.cvUserRoleOptions = userRoleListResp.resp_data.data
      }
      catch (err) {
        console.error("Exception occurred at userRoleListConsole() and Exception:", err.message)
      }
    },
    /**
     * organisationList
     */
    async organisationList (searchString = null) {
      let filter = {}

      if (searchString && searchString.trim().length >= 4) {
        filter.search = searchString.trim()
      }

      filter.fields = [ "org_name", "org_city", "org_country", "org_uid" ]
      filter.type = ["UNIV", "ORG", "SCH"]

      const list = await Organisations.organisationListSearch(this, filter)
      if (list.resp_status) {
        this.cvUnivOptions = list.resp_data.data
      }
    },
    /**
     * user Edit Org
     */
    async userOrgEdit () {
      try {
        if (!this.selectedUniversity.org_uid) {
          this.toastMsg = "This action is allowed only for Organisations who are a part of GIDEPreneur"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        let payload = {
          org_id: this.selectedUniversity.org_id,
          gide_user_id: this.vmUserFormData.user_id,
          org_uid: this.selectedUniversity.org_uid
        }

        let userEditOrgResp = await User.userOrgEdit(this, payload)
        ApiResponse.responseMessageDisplay(this, userEditOrgResp)

        if (userEditOrgResp && !userEditOrgResp.resp_status) {
          return false
        }
      }
      catch (err) {
        console.error("Exception occurred at userEditOrg() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * Goto Org Add
     */
    gotoOrgaAdd () {
      window.open("/organisation_add")
    }
  }
}
</script>
<style>
  .update_org{
    align-content: flex-end;
    display: block;
    text-align: right;
  }
</style>
